/**
 * @file view-business-details.tsx
 * @module app/modules/customers/tabs/view-business-details
 * @description Displays read-only business, contact, and address details for a customer profile.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import ChangeDeliveryAddress from "../../../modals/change-delivery-address";
import { OrdersDelivery } from "../../../../utils/constants";

import AddNewAddress from "../../../modals/add-new-address";
import editIcon from "../../../../_admin/assets/media/svg_uTrade/edit-round-dark.svg";
import trashIcon from "../../../../_admin/assets/media/svg_uTrade/trash.svg";
import DeleteModal from "../../../modals/delete";
import { success } from "../../../../Global/toast";
import APICallService from "../../../../api/apiCallService";
import { buyer } from "../../../../api/apiEndPoints";
import { formatDeliveryAddress } from "../../_common/utils/address";

const ViewBusinessDetails = (props: any) => {
  const [changeDeliveryAddress, setChangeDeliveryAddress] = useState(false);
  const [details, setDetails] = useState<any>();
  const [addressModal, setAddressModal] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [isEditAddress, setIsEditAddress] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState<any>();
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [error, setError] = useState("");

  console.log(props, "909090");

  const handleSaveAddress = (address: any) => {
    let temp = { ...details };
    if (address && address._id) {
      address.reference = address._id;
    }
    // temp.record.address = address;
    setDetails(temp);
    setChangeDeliveryAddress(false);
    setAddressModal(false);
    setIsEditAddress(false);
    setSelectedAddress(null);
    if(props.onAddressSaved){
      props.onAddressSaved();
    }
  };

  const handleAddressDelete = async () => {
    setDeleteLoader(true);
    let id: any = props?.profileData?.user._id;
    let apiService = new APICallService(
      buyer.deleteAddress,
      "",
      {
        id,
        selectedAddress,
      },
      "",
      "",
      true,
      props.moduleName
    );
    let response = await apiService.callAPI();
    if (response.error) {
      setError(response.error);
      setDeleteLoader(false);
    } else {
      success("Address deleted successfully!");
      props.onAddressSaved();
      setDeleteConfirm(false);
    }
    setDeleteLoader(false);
  };

  return (
    <>
      {addressModal && (
        <AddNewAddress
          show={addressModal}
          onHide={() => {
            setAddressModal(false);
            setIsEditAddress(false);
            setSelectedAddress(null);
          }}
          onSaveAddress={handleSaveAddress}
          selectedCustomer={props.profileData?.user?._id}
          details={
            props.profileData?.user.deliveryAddresses &&
            props.profileData?.user.deliveryAddresses.length
              ? props.profileData?.user.deliveryAddresses.find(
                  (item: any) => item._id === selectedAddress
                )
              : {}
          }
          phone={props.profileData?.user?.phone}
          moduleName={OrdersDelivery}
          isEdit={isEditAddress}
        />
      )}
      {deleteConfirm && (
        <DeleteModal
          show={deleteConfirm}
          onHide={() => setDeleteConfirm(false)}
          // service={selectedProduct}
          handleDelete={handleAddressDelete}
          error={error}
          loading={deleteLoader}
          serviceName="Address"
          message={`Are you sure you want to delete address?`}
          warnMessage={`By continuing, the address will
          be removed permanently`}
        />
      )}
      <Card className="border mb-8">
        <Card.Header className="bg-light align-items-center">
          <h3 className="fs-22 fw-700 mb-0">Basic details</h3>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <Row className="mb-7">
                <Col lg={4}>
                  <label className=" fs-16 fw-500 text-dark">Name:</label>
                </Col>
                <Col lg={8}>
                  <span className="fw-bolder fs-16 fw-600 text-dark">
                    {" "}
                    {props.profileData?.user.name}{" "}
                  </span>
                </Col>
              </Row>
              <Row className="mb-7">
                <Col lg={4}>
                  <label className=" fs-16 fw-500 text-dark">
                    Phone number:
                  </label>
                </Col>
                <Col lg={8}>
                  <span className="fs-16 fw-600 text-dark">
                    {props.profileData?.user.phoneCountry}{" "}
                    {props.profileData?.user.phone}
                  </span>
                </Col>
              </Row>
              <Row className="mb-7">
                <Col lg={4}>
                  <label className=" fs-16 fw-500 text-dark">TIN number:</label>
                </Col>
                <Col lg={8}>
                  <span className="fs-16 fw-600 text-dark">
                    {props.profileData?.user.business?.tinNumber
                      ? props.profileData?.user.business?.tinNumber
                      : "NA"}
                  </span>
                </Col>
              </Row>
              {props.profileData?.user.business.types.length ? (
                <Row className="mb-7">
                  <Col lg={4}>
                    <label className=" fs-16 fw-500 text-dark">
                      Business type:
                    </label>
                  </Col>
                  <Col lg={8}>
                    <span className="fs-16 fw-600 text-dark">
                      {
                        props.profileData?.user.business.types[0].reference
                          .title
                      }
                    </span>
                  </Col>
                </Row>
              ) : (
                <></>
              )}
              <Row className="mb-7">
                <Col lg={4}>
                  <label className=" fs-16 fw-500 text-dark">
                    Customer category:
                  </label>
                </Col>
                <Col lg={8}>
                  <span className="fs-16 fw-600 text-dark">
                    {props.profileData?.user.category?.title || "-"}
                  </span>
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row className="mb-7">
                <Col lg={4}>
                  <label className=" fs-16 fw-500 text-dark">
                    Business name:
                  </label>
                </Col>
                <Col lg={8}>
                  <span className="fw-bolder fs-16 fw-600 text-dark">
                    {props.profileData?.user.business.name
                      ? props.profileData?.user.business.name
                      : "NA"}
                  </span>
                </Col>
              </Row>
              <Row className="mb-7">
                <Col lg={4}>
                  <label className=" fs-16 fw-500 text-dark">Email:</label>
                </Col>
                <Col lg={8}>
                  <span className="fs-16 fw-600 text-dark">
                    {props.profileData?.user.email
                      ? props.profileData?.user.email
                      : "NA"}
                  </span>
                </Col>
              </Row>
              <Row className="mb-7">
                <Col lg={4}>
                  <label className=" fs-16 fw-500 text-dark">VAT number</label>
                </Col>
                <Col lg={8}>
                  <span className="fs-16 fw-600 text-dark">
                    {props.profileData?.user.business.vatNumber
                      ? props.profileData?.user.business.vatNumber
                      : "NA"}
                  </span>
                </Col>
              </Row>
              <Row className="mb-7">
                <Col lg={4}>
                  <label className=" fs-16 fw-500 text-dark">
                    Business address:
                  </label>
                </Col>
                <Col lg={8}>
                  <span className="fs-16 fw-600 text-dark">
                    {props.profileData?.user.business?.address
                      ? props.profileData?.user.business?.address
                      : "NA"}
                  </span>
                </Col>
              </Row>
              <Row className="mb-7">
                <Col lg={4}>
                  <label className=" fs-16 fw-500 text-dark">
                    Customer Type:
                  </label>
                </Col>
                <Col lg={8}>
                  <span className="fs-16 fw-600 text-dark">
                    {props.profileData?.user?.isPharmacyVendor
                      ? "Pharmacy"
                      : "Utrade"}
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Card className="border mb-8">
        <Card.Header className="bg-light align-items-center release-highlighter--customer-delivery-address-header">
          <h3 className="fs-22 fw-700 mb-0">Delivery address</h3>
        </Card.Header>
        {props.profileData?.user.deliveryAddresses.length ? (
          <Card.Body>
            <Row className="g-5">
              {props.profileData?.user.deliveryAddresses.map(
                (delivery: any) => {
                  return (
                    <Col md={6}>
                      <div className="border p-6 border-r10px">
                        <div className="d-flex flex-column">
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="fs-15 fw-600" style={{ whiteSpace: "pre-line" }}>
                              {formatDeliveryAddress(delivery)}
                            </span>
                            <div className="d-flex gap-2">
                              <Button
                                variant="link"
                                className="btn-flush"
                                data-analytics-event="customers_view_business_details_edit_address_clicked"
                                onClick={() => {
                                  setAddressModal(true);
                                  setIsEditAddress(true);
                                  setSelectedAddress(delivery._id);
                                }}
                              >
                                <img src={editIcon} alt="" />
                              </Button>
                              <Button
                                variant="link"
                                className="btn-flush"
                                data-analytics-event="customers_view_business_details_delete_address_clicked"
                                onClick={() => {
                                  setDeleteConfirm(true);
                                  setSelectedAddress(delivery._id);
                                }}
                              >
                                <img src={trashIcon} alt="" />
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  );
                }
              )}
            </Row>
          </Card.Body>
        ) : (
          <div
            className="fs-16 fw-500 text-dark my-4"
            style={{ marginLeft: "30px" }}
          >
            No address added yet
          </div>
        )}
        <div className="d-flex justify-content-start mb-2 ms-8">
          <Button
            variant="link"
            className="btn-flush text-primary fs-16 fw-bold"
            data-analytics-event="customers_view_business_details_add_address_clicked"
            onClick={() => {
              setAddressModal(true);
              setSelectedAddress(null);
            }}
          >
            + Add new address
          </Button>
        </div>
      </Card>

      {changeDeliveryAddress && (
        <ChangeDeliveryAddress
          show={changeDeliveryAddress}
          onHide={() => setChangeDeliveryAddress(false)}
          onSaveAddress={handleSaveAddress}
          details={details}
          moduleName={OrdersDelivery}
        />
      )}
    </>
  );
};
export default ViewBusinessDetails;
